import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSession, useLogout } from '@/services/auth';
import { useUIStore } from '@/stores/uiStore';
import { AccessForm } from '@/components/auth/AccessForm';
import { nb } from '@/i18n/nb';
import s from './FooterChrome.module.css';

// text-micro chrome beneath the cards (ADR-0023). Personvern + Kontakt are always
// present; the rest is auth-contextual. The Rediger entry is a role="switch" bound to
// uiStore.editMode (server authorisation is independent — the toggle is cosmetic).
export function FooterChrome() {
  const { user } = useSession();
  const editMode = useUIStore((state) => state.editMode);
  const toggleEditMode = useUIStore((state) => state.toggleEditMode);
  const logout = useLogout();
  const [accessOpen, setAccessOpen] = useState(false);

  const isOwnerPlus = user?.role === 'owner' || user?.role === 'admin';

  return (
    <>
      <footer className={s.footer}>
        <Link to="/personvern" className={s.link}>
          {nb.footer.personvern}
        </Link>
        <Sep />
        <Link to="/kontakt" className={s.link}>
          {nb.footer.kontakt}
        </Link>

        {user ? (
          <>
            <Sep />
            <span className={s.name}>{user.displayName}</span>
            <Sep />
            <Link to="/profil" className={s.link}>
              {nb.footer.minProfil}
            </Link>
            {isOwnerPlus && (
              <>
                <Sep />
                <Link to="/admin" className={s.link}>
                  {nb.footer.admin}
                </Link>
              </>
            )}
            <Sep />
            <button
              type="button"
              role="switch"
              aria-checked={editMode}
              className={s.link}
              onClick={toggleEditMode}
            >
              {editMode ? nb.footer.avsluttRediger : nb.footer.rediger}
            </button>
            <Sep />
            <button
              type="button"
              className={s.link}
              onClick={() => logout.mutate()}
              disabled={logout.isPending}
            >
              {nb.footer.loggUt}
            </button>
          </>
        ) : (
          <>
            <Sep />
            <button type="button" className={s.link} onClick={() => setAccessOpen(true)}>
              {nb.footer.loggInn}
            </button>
          </>
        )}
      </footer>

      <AccessForm open={accessOpen} onClose={() => setAccessOpen(false)} />
    </>
  );
}

function Sep() {
  return (
    <span className={s.sep} aria-hidden="true">
      ·
    </span>
  );
}
